export const Header: React.FC = () => {
  return (
    <div className="logo">
      <img src="logo-supra-couleur2.png" width="200" alt="Logo"/>
    </div>
  );
};

export default Header;
